import { IonButton } from "@ionic/react";
import { chevronBackOutline, chevronForwardOutline } from "ionicons/icons";
import { useRef, useState } from "react";
import { v4 } from "uuid";
import ButtonSlide from "./ButtonSlide";
import CheckBox from "./CheckBox";
import Correction from "./Correction";
import Mark from "./Mark";
import Question from "./Question";

export interface IQuestion {
  question: string;
  awnser: string[];
  valide: string[];
}

const getNbValides = (questions: IQuestion[]) => {
  let nbValides = 0;

  for (const question of questions) {
    for (const valides of question.valide) {
      nbValides += valides.length;
    }
  }
  return nbValides;
};

interface Props {
  _id: string;
  questions: IQuestion[];
}

const Quizz: React.FC<Props> = ({ questions, _id }) => {
  const [step, setStep] = useState<number>(0);
  const score = useRef<number>(0);
  const mark = useRef<number>();
  const userAnwser = useRef<Map<string, boolean>>(new Map());

  if (questions === undefined) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <IonButton shape="round" color="dark" disabled>
          Disponible Prochainement
        </IonButton>
      </div>
    );
  }
  const nbStep = questions.length - 1;

  const calculateMark = () => {
    const nbValides = getNbValides(questions);
    mark.current = Math.max(
      Number.parseFloat(((score.current / nbValides) * 20).toPrecision(2)),
      0
    );
  };

  const handleAddScore = (
    scoreToAdd: number,
    isChecked: boolean,
    indexQ: number,
    indexA: number
  ) => {
    score.current += scoreToAdd;
    userAnwser.current.set(
      indexQ.toString() + "-" + indexA.toString(),
      isChecked
    );
  };

  const nextStep = () => {
    if (step < questions.length) setStep((old) => old + 1);
  };
  const prevStep = () => {
    if (step - 1 >= 0) setStep((old) => old - 1);
  };

  return (
    <div>
      {questions.map((question, indexQ) => (
        <div key={v4()}>
          {indexQ === step && (
            <Question label={question.question} nbStep={nbStep} step={step}>
              {question.awnser.map((answer, indexA) => (
                <CheckBox
                  key={indexA}
                  handleAddScore={(scoreToAdd, isChecked) =>
                    handleAddScore(scoreToAdd, isChecked, indexQ, indexA)
                  }
                  value={
                    userAnwser.current.get(
                      indexQ.toString() + "-" + indexA.toString()
                    ) ?? false
                  }
                  answer={answer}
                  index={indexA.toString()}
                  isValide={question.valide.includes(indexA.toString())}
                />
              ))}
            </Question>
          )}
        </div>
      ))}
      {step === questions.length && (
        <>
          <Mark mark={mark.current ?? 0} _id={_id} />
          <Correction questions={questions} userAnwser={userAnwser.current} />
        </>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ButtonSlide
          isDisabled={step === 0}
          isDisplayed={step >= 0 && step <= nbStep}
          label="Retour"
          onClick={prevStep}
          iconLeft={chevronBackOutline}
        />
        <ButtonSlide
          isDisplayed={step >= 0 && step < nbStep}
          label="Suivant"
          onClick={nextStep}
          iconRight={chevronForwardOutline}
        />
        <ButtonSlide
          label="Voir les réponses"
          onClick={() => {
            calculateMark();
            nextStep();
          }}
          isDisplayed={step === nbStep}
        />
      </div>
    </div>
  );
};

export default Quizz;
